import { URLS } from '../constants/URLS';

/**
 * Extracts the media ID from a video object or returns the raw ID.
 * Uses mediaId (shared content) with fallback to vidLibId (original).
 */
export function getMediaId(videoOrId: any): any {
  if (typeof videoOrId === 'object' && videoOrId !== null) {
    return videoOrId?.mediaId || videoOrId?.vidLibId;
  }
  return videoOrId;
}

/**
 * Builds a video thumbnail URL.
 * Accepts either a video object (with vidLibId/mediaId) or a raw ID.
 */
export function getVideoThumbnail(videoOrId: any, suffix: string = '_thumb.jpg'): string {
  const id = getMediaId(videoOrId);
  if (!id) return '';
  return `${URLS.imgUrl}VID_${id}${suffix}`;
}

/**
 * Builds a video stream filename (e.g. VID_123_drm_meta.mpd).
 * Accepts either a video object or a raw ID.
 */
export function getVideoStreamFile(videoOrId: any, suffix: string = '_drm_meta.mpd'): string {
  const id = getMediaId(videoOrId);
  if (!id) return '';
  return `VID_${id}${suffix}`;
}
